import { MessageCircle } from "lucide-react";

const StickyContact = () => {
  return (
    <a
      href="https://wa.me/31619038233"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2.5 border border-foreground/30 text-foreground bg-background/80 backdrop-blur-sm px-5 py-3 rounded-full hover:scale-105 transition-transform duration-300 group"
    >
      <MessageCircle className="w-4 h-4" />
      <span className="text-xs uppercase tracking-[0.15em] font-display">Contact Us</span>
    </a>
  );
};

export default StickyContact;
